import React from 'react';
import NewDomain from './NewDomain';
import { useQuery } from 'react-query';
import Loading from 'components/common/loading/Loading';

const NewDomainContainer = ({ topWarningHeight }) => {
  const { data: domainList, isLoading } = useQuery('/prices/domains/extensions');
  if (isLoading) {
    <Loading gap={200} />;
  }
  return <NewDomain topWarningHeight={topWarningHeight} domainList={domainList} />;
};
export default NewDomainContainer;
